export { default } from './globalLoading';
